import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const RootRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("bgc_token");

    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    try {
      const decoded = jwtDecode(token);

      const currentTime = Date.now() / 1000;

      if (decoded.exp < currentTime) {
        localStorage.clear();
        navigate("/login", { replace: true });
        return;
      }

      const role = localStorage.getItem("user_role");

      switch (role) {
        case "ADMIN":
          navigate("/admin", { replace: true });
          break;

        case "EMPLOYEE":
          navigate("/employee", { replace: true });
          break;

        case "USER":
          navigate("/client", { replace: true });
          break;

        default:
          navigate("/login", { replace: true });
      }
    } catch (e) {
      localStorage.clear();
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  return null;
};

export default RootRedirect;